'use strict';

ServiceRequesterClassFactory.$inject = [
	'$q',
	'mx.SolutionBuilderAgent.DataQueryService',
	'mx.SolutionBuilderAgent.ExternalServiceManager',
	'mx.SolutionBuilderAgent.Http',
	'mx.shell.DownloadHelpService',

	'mx.sb.Agent.DataQuery.ClientDataRequester',
];
export default function ServiceRequesterClassFactory(
	$q,
	dataQueryService,
	externalServiceManager,
	http,
	downloadHelpService,

	ClientDataRequester
) {
	/**
	 * @ngdoc Class
	 * @name mx.sb.Agent.DataQuery.ServiceRequester
	 *
	 * @description
	 * Class DataDefinition Requester
	 *
	 */

	function ServiceRequester(dataQuery) {
		ClientDataRequester.call(this, dataQuery);

		this.options = {};

		this.supportedPreprocessors = {
			search: true,
			paging: true,
			sorting: true,
			columnSearch: true,
			advanceSearch: true,
		};
	}

	ServiceRequester.prototype = angular.extend(Object.create(ClientDataRequester.prototype), {
		setDataQuery: function (dataQuery) {
			ClientDataRequester.prototype.setDataQuery(dataQuery);
			this._executeOptions = externalServiceManager.getListExecuteOptions(this.dataQuery, mx.SolutionBuilderAgent.SupportedOperations.ReadObjectsByODataQuery);

			var preFunc = this._executeOptions.typeInfo.MakeExpression();

			this.expressionFunctions = {};
			dataQuery.Columns.forEach(function (column) {
				if (!column.Expression || !column.Expression.match(/[^\w$_]/g)) {
					return;
				}

				this.expressionFunctions[column.Name] = preFunc(column.Expression);
			}, this);
		},

		entitiesEqualityFunction: function (entityA, entityB) {
			var identifier = this._executeOptions.typeInfo.Identifier;
			if (identifier) {
				return (entityA && entityB && entityA[identifier] === entityB[identifier]) || entityA === entityB;
			} else {
				return entityA === entityB;
			}
		},

		_loadExpressions: function (rawEntity, displayEntity, changedColumns) {
			changedColumns.forEach(function (column) {
				if (typeof this.expressionFunctions[column.Name] !== 'function') {
					return;
				}
				displayEntity[column.Name] = this.expressionFunctions[column.Name](rawEntity);
			}, this);

			return $q.when();
		},

		_getDisplayEntity: function (rawEntity, displayEntity, changedColumns) {
			var defer = $q.defer();

			this._loadExpressions(rawEntity, displayEntity, changedColumns).finally(function () {
				changedColumns = changedColumns.filter(function (column) {
					return !column.HasQuery;
				});

				ClientDataRequester.prototype._getDisplayEntity
					.call(this, rawEntity, displayEntity, changedColumns)
					.then(function (displayEntity) {
						defer.resolve(displayEntity);
					})
					.catch(function (e) {
						defer.reject(e);
					});
			});

			return defer.promise;
		},
	});

	return ServiceRequester;
}
